import { useEffect } from 'react';
import { RemitReport } from 'src/apis/remit-reporting/types';
import { useAxios } from 'src/hooks/use-axios';
import { handleRequestError } from 'src/utils/axios-config';

export function useRemitReportHistory(secondaryTradeId: string) {
  const reportsRequest = useAxios(
    (axios, signal) =>
      axios.request<RemitReport[]>({
        signal,
        url: `${PRISMA_CONFIG.remitReporting}/api/platform/secondary-reports/${secondaryTradeId}`,
        method: 'GET',
      }),
    {
      neededOnPageLoad: false,
      onError(error) {
        const [_, report] = handleRequestError(error, () => {});

        if (report) reportError(error);

        return error;
      },
    }
  );

  const { execute, setResponse, refresh, ...restReportsRequest } =
    reportsRequest;

  useEffect(() => {
    if (PRISMA_CONFIG.remitReporting != null) execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secondaryTradeId]);

  if (PRISMA_CONFIG.remitReporting == null) return;

  return restReportsRequest;
}

export type RemitReportHistoryRequest = ReturnType<
  typeof useRemitReportHistory
>;
